var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LabelKey } from '@/models/Label';
let SubjectStatusSelect = class SubjectStatusSelect extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.statusses = [UserSubjectStatusEnum.BUSY, UserSubjectStatusEnum.HIGHLIGHTED, UserSubjectStatusEnum.LESSON_DONE, UserSubjectStatusEnum.OLD, UserSubjectStatusEnum.FINISHED, UserSubjectStatusEnum.CLOSED, UserSubjectStatusEnum.INACTIVE, UserSubjectStatusEnum.FUTURE];
        this.statusItems = [];
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters
        // #endregion
        // #region Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle & Init
    mounted() {
        this.generateStatusItems();
    }
    // #endregion
    // #region Class methods
    generateStatusItems() {
        if (!this.$store.state.labels) {
            return;
        }
        this.statusses.forEach((status) => {
            const label = this.$store.state.labels.find((label) => {
                return label.key === status;
            });
            this.statusItems.push({
                value: status,
                text: !label || label.value === label.key ? this.$tc(`idp.status.${status}`, 2) : label.value,
            });
        });
        if (this.exclude && this.exclude.length) {
            this.statusItems = this.statusItems.filter((item) => {
                return !this.exclude.includes(item.value);
            });
        }
        this.isLoading = false;
    }
    getDotColor(key) {
        switch (key) {
            case LabelKey.HIGHLIGHTED:
                return '#ffc100';
            case LabelKey.BUSY:
                return '#008ac4';
            case LabelKey.CLOSED:
                return '#d0021b';
            case LabelKey.OLD:
                return '#ff7800';
            case LabelKey.INACTIVE:
                return '#9b9b9b';
            case LabelKey.FINISHED:
                return '#00b900';
            case LabelKey.FUTURE:
                return '#000000';
            case LabelKey.LESSON_DONE:
                return '#800080';
            default:
                return '#9b9b9b';
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Array)
], SubjectStatusSelect.prototype, "exclude", void 0);
SubjectStatusSelect = __decorate([
    Component({
        components: {
        //
        },
    })
], SubjectStatusSelect);
export default SubjectStatusSelect;
